import { IconMediaVideo16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import { nbspJsString } from '@/packages/shared-ui/symbols/symbols';

import { FeatureLabel, type FeatureLabelTooltipPlacement } from '../FeatureLabel';

type HasVideoBadgeProps = {
  placement?: FeatureLabelTooltipPlacement;
};

export const HasVideoBadge: FC<HasVideoBadgeProps> = props => {
  const { placement } = props;

  return (
    <FeatureLabel
      dataTestId="card-gallery.video-badge"
      icon={<IconMediaVideo16 color="text-inverted-default" />}
      placement={placement}
      title={`Объявление${nbspJsString}с${nbspJsString}видео`}
    />
  );
};
